import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { initialAndSearchStateSetter } from '../../Utility/InitialAndSearchStateSetter/InitialAndSearchStateSetter';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { mapStateToPropsForAllData } from '../../Utility/MapStateToPropsForAllData/MapStateToPropsForAllData';
import { connect } from 'react-redux';


function Leads({ allDataOfContact, searchedDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const [isLoading, setIsLoading] = useState(true);
  const [leadsData, setLeadsData] = useState({});
  const navigate = useNavigate();
  const { searchedKeyword } = useParams();

  useEffect(() => {

    initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setLeadsData, allDataOfContact);


  }, [allDataOfContact, searchedDataOfContact, isLoading, searchedKeyword]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', marginLeft: 2, fontWeight: 'bold' }}
            >
              Leads
            </Typography>
            { isLoading ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
      <CircularProgress />
    </Box> : ((leadsData?.data && leadsData?.data?.Leads && leadsData?.data?.Leads?.totalSize) != 0 ? <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Phone</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Company</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Industry</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {leadsData?.data && leadsData?.data?.Leads?.records?.map((leadData) => {
          
          const leadIdOfContact = generateRandomString()+"00JZ3"+leadData.Id+generateRandomString();
          
          return (
            <TableRow key={leadData.Id}>
              <TableCell><Link to={`/LeadDetail/${leadIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{leadData.Name}</Link></TableCell>
              <TableCell>{leadData.Phone}</TableCell>
              <TableCell>{leadData.Company}</TableCell>
              <TableCell>{leadData.Email}</TableCell>
              <TableCell>{leadData.Industry}</TableCell>
              <TableCell >{leadData.Status}</TableCell>
            </TableRow>
          )
        })}
        </TableBody>
      </Table> : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>) }
              
       
            </Grid> 
            
          </Container>
  )
}

export default connect(mapStateToPropsForAllData)(Leads);